<template>
  <b-modal v-model="modalAberto" :prefix='prefix' size="xl" @hidden="cancelar" button-size="md" hide-footer
    :title="title">
    <CatalogoConsultaPedidos :prefix='updatedPrefix' :id="id"></CatalogoConsultaPedidos>
  </b-modal>
</template>

<script>

import CatalogoConsultaPedidos from '@/modules/patrimonio/catalogo-consulta/CatalogoConsultaPedidos.vue'

export default {
  name: "ModalCatalogoConsultaPedidos",
  components: {
    CatalogoConsultaPedidos
  },
  props: {
    id: Number,
    prefix: {
      type: Array,
      default: () => ['Consultar Catálogo'],
    }
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, 'Meus Pedidos']
    },
    title() {
      return this.updatedPrefix.join(" > ")
    },
  },
  data() {
    return {
      modalAberto: true,
    }
  },
  methods: {
    cancelar() {
      this.$emit('fecharModal')
    },

  }
}

</script>
